import GroupsAPI, { IGroupMember } from 'api/GroupsAPI';
import { createPaginatedLookupStore } from 'stores/index';

export const GroupMembersStore = createPaginatedLookupStore<{ groupId: number }, IGroupMember>(
  ({ groupId }, page) => GroupsAPI.listGroupMembers(groupId, page),
  ({ groupId }) => groupId.toString(),
);
